/* src/app/components/connectivity-overlay/connectivity-overlay.component.scss */
.connectivity-wrapper {
  position: fixed;
  inset: 0;
  z-index: 1000001;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  pointer-events: all;
}
.connectivity-wrapper.under-splash {
  z-index: 20000;
}
.connectivity-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(1.5px);
  backdrop-filter: blur(1.5px);
}
.connectivity-container {
  position: relative;
  z-index: 2;
  width: 88%;
  max-width: 370px;
  text-align: center;
  background: var(--ion-color-light);
  border-radius: 20px;
  padding: 2rem 1.4rem 1.5rem;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(255, 255, 255, 0.12);
  transform-origin: center center;
  will-change: transform, opacity;
}
.connectivity-icon-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  min-height: 48px;
}
.connectivity-icon {
  font-size: 3rem;
  color: var(--ion-color-primary);
}
.connectivity-spinner {
  width: 2.5rem;
  height: 2.5rem;
  color: var(--ion-color-primary);
}
.connectivity-title {
  margin: 0 0 0.75rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--ion-color-primary);
}
.connectivity-message {
  margin: 0 0 1.25rem;
  font-size: 0.95rem;
  line-height: 1.45;
  color: var(--ion-text-color);
  opacity: 0.85;
}
.connectivity-actions {
  display: flex;
  justify-content: center;
}
.connectivity-container--shake {
  animation: connectivity-shake 0.45s ease;
}
@keyframes connectivity-shake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-6px);
  }
  40% {
    transform: translateX(6px);
  }
  60% {
    transform: translateX(-4px);
  }
  80% {
    transform: translateX(4px);
  }
}
/*# sourceMappingURL=connectivity-overlay.component.css.map */
